import React from 'react'


const AddBooking = () => {





    return (
        <>
 


            <div className='pt-4'>
         
                <div className='bg-white drop-shadow-sm rounded-md mt-8 pb-6'>
                    <h2 className='card-title'> Add Booking</h2>
                    <div className='px-10'>
                        <form>
                            <div className='grid grid-cols-2 gap-x-5 mb-4'>
                                <div>
                                    <label htmlFor="name">First name *</label>
                                    <input type="text" required />
                                </div>
                                <div>
                                    <label htmlFor="name">Last name </label>
                                    <input type="text" />
                                </div>
                            </div>
                            <div className='grid grid-cols-2 gap-x-5 mb-4'>
                                <div>
                                    <label htmlFor="email">Email *</label>
                                    <input type="email" id='email' />
                                </div>
                                <div>
                                    <label htmlFor="name">Mobile</label>
                                    <input type="number" />
                                </div>
                            </div>
                            <div className='grid grid-cols-2 gap-x-5 mb-4'>
                                <div>
                                    <label htmlFor="email">Gender</label>
                                    <select name="" id="">
                                        <option value="">Male</option>
                                        <option value="">Female</option>
                                        <option value="">Other</option>
                                    </select>
                                </div>
                                <div>
                                    <label htmlFor="name">City</label>
                                    <input type="text" />
                                </div>
                            </div>
                            <div className='grid grid-cols-2 gap-x-5 mb-4'>
                                <div>
                                    <label htmlFor="email">Arrived Date</label>
                                    <input type="date" />
                                </div>
                                <div>
                                    <label htmlFor="name">Depart Date</label>
                                    <input type="date" />
                                </div>
                            </div>
                            <div className='mb-4'>
                                <div>
                                    <label htmlFor="email">Upload</label>
                                    <input type="file" multiple />
                                </div>
                            </div>

                            <div className='pt-2'>
                                <button type="submit" className=" btn text-[#444] bg-gray-300 cursor-not-allowed" disabled>Submit</button>

                                <button type="submit" className="ml-4 btn btn-danger">Cancel</button>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </>

    )
}

export default AddBooking